import { Component, computed, effect, inject, input, output, signal } from '@angular/core';
import { FormArray, FormGroup } from '@angular/forms';
import { TNil } from '@app/app.interface';
import { ICampaignCreatorForm, ICtaForm } from '@campaign-form/campaign-form.interface';
import { IDeliverableConfigurationApi } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/deliverable-list.interface';
import { IGamePlayDeliverableForm } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/deliverable-step/deliverable-list/game-play/game-play.interface';
import { ExecutionService } from '@campaign-form/form-fields/creators-and-ctas/deliverable-flow-dialog/execution-step/execution-list/execution/execution.service';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateModule } from '@ngx-translate/core';
import { ExecutionExpectedKpiListComponent } from './execution-expected-kpi-list/execution-expected-kpi-list.component';
import { ExpectedKpiStepStore } from './expected-kpi-step.store';

@Component({
  imports: [ExecutionExpectedKpiListComponent, TranslateModule],
  providers: [ExpectedKpiStepStore],
  selector: 'app-expected-kpi-step',
  templateUrl: './expected-kpi-step.component.html',
})
export class ExpectedKpiStepComponent {
  public readonly campaignCreatorsValue = input.required<FormGroup<ICampaignCreatorForm>['value'][]>();
  public readonly selectedPlatformFeature = input.required<EPlatformFeature | null>();
  public readonly createMode = input.required<boolean>();

  public readonly gamePlayValues = input<FormArray<FormGroup<IGamePlayDeliverableForm>>['value']>([]);
  public readonly reached = input<boolean>(false);
  public readonly ctaForm = input<FormGroup<ICtaForm> | null>(null);
  public readonly deliverableConfigurations = input<IDeliverableConfigurationApi[] | null>(null);
  public readonly customModeCreatorId = input<string | TNil>(null);

  public readonly displayHeightPlaceholder = signal<boolean>(false);

  public readonly customModeDisabled = output<void>();

  public readonly creators = computed(() => {
    return this.campaignCreatorsValue().map((cc) => cc.creator!) ?? [];
  });
  public readonly customModeCreator = computed(() => {
    return this.campaignCreatorsValue().find((cc) => cc.creatorId === this.customModeCreatorId())?.creator;
  });
  public readonly customModeCreatorName = computed(() => {
    return this.customModeCreator()?.name ?? '';
  });

  public readonly availableKpis = computed(() => this.expectedKpiStepStore.availableKpis$());

  private readonly expectedKpiStepStore = inject(ExpectedKpiStepStore);
  private readonly executionService = inject(ExecutionService);

  private addedFirstExecution = false;

  constructor() {
    effect(() => {
      if (this.selectedPlatformFeature()) {
        this.expectedKpiStepStore.fetchAvailableKpis(this.selectedPlatformFeature()!);
      }
    });

    effect(() => {
      if (
        this.reached() &&
        this.createMode() &&
        this.selectedPlatformFeature() &&
        !this.addedFirstExecution &&
        !this.ctaForm()?.controls.executions.length
      ) {
        this.displayHeightPlaceholder.set(true);
        this.addedFirstExecution = true;

        requestAnimationFrame(() => {
          this.displayHeightPlaceholder.set(false);
          this.ctaForm()?.controls.executions.push(
            this.executionService.getConfig().createForm(this.selectedPlatformFeature()!),
          );
        });
      }
    });
  }
}
